export default __webpack_public_path__ + "static/media/004-B-musique.d4b55150.svg";